// DapNow contact. WhatsApp is not yet activated on this dedicated number.
export const SUPPORT_PHONE = "+41 79 851 13 98";
export const SUPPORT_PHONE_RAW = "41798511398";

const DEFAULT_INFO_TEXT = "Ciao, vorrei informazioni su DapNow per la mia azienda.";
export const PRIVATE_DRIVER_INFO_TEXT = "Ciao DapNow, vorrei informazioni sul futuro servizio per driver privati e sulle modalità per partecipare quando sarà disponibile.";

export function informationUrl(text = DEFAULT_INFO_TEXT) {
  return `mailto:support@dap-now.ch?subject=Informazioni%20DapNow&body=${encodeURIComponent(text)}`;
}

export const SERVICE_OPERATOR = "DapNow, un servizio di SwissNat SA";
export const OPERATOR_ADDRESS = "Via Mastri Ligornettesi 14, 6853 Ligornetto, Svizzera";
export const OPERATOR_VAT = "CHE-325.515.575 IVA";
